export default "__VITE_ASSET__9d95905a__"